import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {baseUrl} from '@/config/env';




export const snapOrderOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    //menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "订单编号",
            search: true,
            prop: "number",
            type: "input"
        },
        {
            label: '抢购人',
            search: true,
            prop: 'realName',
        },{
            label: '店铺名称',
            prop: 'shopName',
        },{
            label: '店铺地址',
            prop: 'shopAddress',
        },
        {
            label: '抢购账号',
            search: true,
            prop: 'account'

        },
        {
            label: '抢购商品',
            search: true,
            prop: 'goodsName'
        },
        {
            label: '商品品牌',
            prop: 'brand'
        }
        ,{
            label: '商品型号',
            search: true,
            prop: 'type'
        },
        {
            label: '抢购数量',
            prop: 'count'
        },


        {
            label: "抢购客户端",
            prop: "clientType",
            type: "radio",
            dicData: DIC.CLIENT_TYPE,
        },{
            label: '商品单价',
            prop: 'price'
        },{
            label: '费用总计',
            prop: 'amount'
        },{
            label: '平台抽成',
            prop: 'platformAmount'
        },
        {
            label: "下单时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },{
            label: "支付时间",
            prop: "payTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "radio",
            search: true,
            dicData: DIC.SNAP_ORDER_STATUS,
        }

    ]
};